var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fullSize", staticStyle: { width: "100%" } },
    [
      _vm.isNotDesktop
        ? _c("div", { staticClass: "navDraw-helper" })
        : _vm._e(),
      _c("v-tabs-items", { staticClass: "accent fullSize" }, [
        _c(
          "div",
          { class: { fullSize: _vm.loadingCharts || _vm.loadingDefinitions } },
          [
            _vm.loadingCharts || _vm.loadingDefinitions
              ? _c("loading-page", { staticClass: "fullSize" })
              : !_vm.layout.length
              ? _c("default-page", {
                  attrs: {
                    imageUrl: "/img/dynamic-src-images/price-watcher.svg",
                    title: "Price Watcher",
                    text: _vm.emptyPageText,
                    buttonText: "Create",
                  },
                  on: { "button-clicked": _vm.openChartDialog },
                })
              : _c(
                  "div",
                  {
                    staticClass: "mx-2",
                    staticStyle: {
                      "overflow-y": "auto",
                      "overflow-x": "hidden",
                      height: "calc(100vh - 58px)",
                    },
                  },
                  [
                    _vm.layout.length
                      ? _c(
                          "grid-layout",
                          {
                            ref: "grid-layout",
                            staticClass: "PW-card-layout",
                            class: _vm.$vuetify.theme.dark
                              ? "darkTheme"
                              : "lightTheme",
                            staticStyle: { "margin-bottom": "120px" },
                            attrs: {
                              layout: _vm.layout,
                              "is-draggable": true,
                              "is-resizable": _vm.resizable,
                              "vertical-compact": true,
                              "use-css-transforms": true,
                              margin: [20, 20],
                              "col-num": 18,
                              "row-num": 2,
                              "row-height": 64,
                              "min-h": 6,
                              "min-w": 6,
                              "is-mirrored": false,
                            },
                            on: {
                              "update:layout": function ($event) {
                                _vm.layout = $event
                              },
                            },
                          },
                          _vm._l(_vm.layout, function (item) {
                            return _c(
                              "grid-item",
                              {
                                key: item.i,
                                ref: `item-${item.i}`,
                                refInFor: true,
                                staticClass: "draggable simple-slow-opacityAN",
                                class: {
                                  "my-4": _vm.$vuetify.breakpoint.xsOnly,
                                },
                                staticStyle: { "touch-action": "none" },
                                attrs: {
                                  static: !item.draggable,
                                  x: item.x,
                                  y: item.y,
                                  w: item.w,
                                  h: item.h,
                                  i: item.i,
                                  minH: 4,
                                  minW: _vm.minimumGridWidth,
                                },
                                on: {
                                  resized: function ($event) {
                                    return _vm.gridResized(
                                      item,
                                      _vm.charts[item.i].type
                                    )
                                  },
                                  moved: function ($event) {
                                    return _vm.saveCardState(item.i, {
                                      eventType: "moved",
                                    })
                                  },
                                },
                              },
                              [
                                _vm.charts[item.i].type ===
                                _vm.VISUALIZATION_TYPES.CHART
                                  ? _c("chart-card", {
                                      ref: item.i,
                                      refInFor: true,
                                      attrs: {
                                        cardInfo: _vm.charts[item.i],
                                        cardSymbol: _vm.charts[item.i].symbols,
                                        draggable: item.draggable,
                                        width: item.w,
                                        height: item.h,
                                        selectedHistoryOption:
                                          _vm.selectedHistoryOption,
                                        isNotDesktop: _vm.isNotDesktop,
                                        definitions: _vm.definitions,
                                        isAdmin: _vm.isAdmin,
                                        connectionLost: _vm.connectionLost,
                                        settingsLoaded: _vm.settingsLoaded,
                                      },
                                      on: {
                                        edit: _vm.showChartConfigurationDialog,
                                        delete:
                                          _vm.showChartDeleteConfirmationDialog,
                                        "draggable-switch": function ($event) {
                                          item.draggable = !item.draggable
                                        },
                                        "change-history-option": (option) =>
                                          _vm.changeHistoryOption(
                                            option,
                                            item.i
                                          ),
                                        "stepper-changed": (stepper) =>
                                          _vm.stepperChanged(stepper, item.i),
                                      },
                                    })
                                  : _vm.charts[item.i].type ===
                                    _vm.VISUALIZATION_TYPES.LIVE_TABLE
                                  ? _c("live-prices-card", {
                                      ref: item.i,
                                      refInFor: true,
                                      attrs: {
                                        definitions: _vm.definitions,
                                        cardInfo: _vm.charts[item.i],
                                        tableHeight: item.h,
                                        watchers: _vm.watchers,
                                        headers: _vm.liveTableHeaders,
                                      },
                                      on: {
                                        delete:
                                          _vm.showChartDeleteConfirmationDialog,
                                        "update-table-symbols": (ev) =>
                                          _vm.updateLiveTableSymbols(
                                            ev,
                                            _vm.charts[item.i]
                                          ),
                                        "update-table-watchers": (ev) =>
                                          _vm.updateLiveTableWatchers(
                                            ev,
                                            _vm.charts[item.i]
                                          ),
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _vm._e(),
                    !_vm.loading
                      ? _c(
                          "v-btn",
                          {
                            style: { bottom: "50px" },
                            attrs: {
                              fab: "",
                              bottom: "",
                              right: "",
                              color: _vm.$vuetify.theme.dark
                                ? "secondary"
                                : "primary",
                              dark: "",
                              fixed: "",
                            },
                            on: {
                              click: function ($event) {
                                _vm.wizardDialog = !_vm.wizardDialog
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("add")])],
                          1
                        )
                      : _vm._e(),
                    _c("chart-configuration", {
                      attrs: {
                        configuration: _vm.chartConfiguration,
                        definitions: _vm.definitions,
                        watchers: _vm.watchers,
                      },
                      on: { save: _vm.updateChartConfiguration },
                      model: {
                        value: _vm.configurationDialog,
                        callback: function ($$v) {
                          _vm.configurationDialog = $$v
                        },
                        expression: "configurationDialog",
                      },
                    }),
                    _c("confirm-dialog", {
                      attrs: {
                        dialog: _vm.confirmDialog,
                        text: _vm.itemDeletionText,
                        acceptButton: "Delete",
                      },
                      on: {
                        "confirmation-event": _vm.deleteChart,
                        "mutate-confirm-dialog": (ev) =>
                          (_vm.confirmDialog = ev),
                      },
                    }),
                  ],
                  1
                ),
            _c("chart-wizard", {
              attrs: { watchers: _vm.watchers, definitions: _vm.definitions },
              on: { create: _vm.createNewChart },
              model: {
                value: _vm.wizardDialog,
                callback: function ($$v) {
                  _vm.wizardDialog = $$v
                },
                expression: "wizardDialog",
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }